export default __webpack_public_path__ + "static/media/shareiconfbprofile.40c7b165.svg";